import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { axInst } from "../../../Components/Login/Service";
import { useSelector } from "react-redux";
import WaterMark from "../../../Components/WaterMark/WaterMark";
import {
  FaClock,
  FaFileInvoice,
  FaListUl,
  FaWrench,
  FaChartLine,
} from "react-icons/fa";
import { BsSpeedometer2 } from "react-icons/bs";

const ServiceSummaryApi = async (selectedFilter) => {
  try {
    const res = await axInst.post("/pvin/service_summary", selectedFilter);
    return res.data;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch service summary");
  }
};

const ServiceSummary = () => {
  const selectedFilter = useSelector(
    (state) => state.filtersPvin.selectedFilter
  );

  const {
    data: SummaryServicesData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["ServiceSummary", selectedFilter],
    queryFn: () => ServiceSummaryApi(selectedFilter),
    cacheTime: 0,
    staleTime: 0,
    enabled: Object.keys(selectedFilter).length > 0,
  });

  if (isFetching)
    return (
      <div className="grid items-center justify-center w-full h-full">
        <Loader />
      </div>
    );

  if (isError)
    return (
      <div className="grid items-center justify-center w-full h-full">
        <p className="text-red-500">Error Occurred</p>
      </div>
    );

  const summary = SummaryServicesData || {};

  const cards = [
    {
      label: "Average Service TAT",
      value: summary.Average_Service_Tat,
      icon: <FaClock className="text-orange-500" />,
      unit: "Hrs",
    },
    {
      label: "Active AMC ",
      value: summary.Active_Amc_Tat,
      icon: <BsSpeedometer2 className="text-blue-500" />,
      unit: "Vehicles",
    },
    {
      label: "Total Job Card",
      value: summary.Total_Job_Card,
      icon: <FaListUl className="text-green-600" />,
      unit: "",
    },
    {
      label: "Open Job Card",
      value: summary.Open_Job_Card,
      icon: <FaWrench className="text-purple-500" />,
      unit: "",
    },
    {
      label: "Average TAT (Non-ACC)",
      value: summary.Average_tat_non_ac,
      icon: <FaChartLine className="text-rose-500" />,
      unit: "Hrs",
    },
    {
      label: "Avg Invoice (Non-ACC) ",
      value: summary.Average_non_invoice,
      icon: <FaFileInvoice className="text-emerald-500" />,
      unit: "Value",
    },
  ];

  return (
    <div className="w-full bg-white rounded-lg shadow-sm p-2 relative">
      <h2 className="pb-1 text-base font-semibold text-[#4c4c4c] border-b border-gray-200 mb-2">
        Service Summary
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
        {cards.map((card, index) => (
          <div
            key={index}
            className="bg-gray-50 border border-gray-200 rounded-xl p-3 flex flex-col justify-between hover:shadow-md transition-shadow items-center"
          >
            <div className="flex items-center justify-between">
              <span className=" font-medium text-gray-600">{card.label}</span>
            </div>
            <div className="text-lg font-bold text-gray-900 mt-2 flex items-center justify-between gap-2">
              {card.icon}
              {card.value !== undefined && card.value !== null
                ? card.value.toLocaleString()
                : "N/A"}
              <span className="text-gray-600 text-sm">{card.unit}</span>
            </div>
          </div>
        ))}
      </div>

      <WaterMark />
    </div>
  );
};

export default ServiceSummary;
